import { DateUtil } from '@/utils'

export function formatApiDateTime(dateVal) {
  if (!dateVal) {
    return ''
  }
  return DateUtil.formatGMTDate(dateVal) || ''
}

export function buildTeamOrderString(teams) {
  return (teams || []).map(function (team) {
    return team.id
  }).filter(function (id) {
    return !!id
  }).join(',')
}

/**
 * 出战球队顺序 → AdminUpdateBMMatchStageGroupTeams.teamIds
 * 按 groupIndex 占位，空位用空字符串；尾部空位可省略
 */
export function buildStageGroupTeamIds(teams) {
  var slots = (teams || []).map(function (team) {
    return team && team.id ? String(team.id) : ''
  })
  while (slots.length > 0 && slots[slots.length - 1] === '') {
    slots.pop()
  }
  return slots.join(',')
}
